module.exports = __webpack_public_path__ + "static/media/comet.b0e44d13.svg";